import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { PG } from '@h2/components/colors'
import { Flex as FlexBase } from '@h2/components/layout/flex'
import { Box as BoxBase } from '@h2/components/layout/box'

const Flex = styled(FlexBase)`
  grid-area: hlt;
  background-color: ${({ color }) => color};
  padding: 20px;

  @media (${features.minWidth.laptop}) {
    padding: 20px 40px;
  }
`
const Box = styled(BoxBase)`
  align-self: center;

  @media (${features.minWidth.laptop}) {
    * {
      text-align: center;
    }

    img,
    span[role='img'] {
      margin-top: 40px;
    }
  }
`
const Highlight = ({ children, color = PG }) => {
  return (
    <Flex color={color}>
      <Box>{children}</Box>
    </Flex>
  )
}

Highlight.propTypes = {
  color: PropTypes.string
}
Highlight.slotName = 'PanelHighlight'

export { Highlight }
